<template>
    <div class="container pb-4 mb-4">
    
    <div class="row mb-3">
        <!-- <div class="col-2">
          <a :href="`https://${advert.url}`" target="_blank" :title="advert.url"><img :src="advert.image" style="height:4.7rem;" class="rounded"></a>
        </div> -->
        <div class="col-4">
        <div class="alert alert-success text-center referral_heading">Views</div>
        <div class="alert alert-dark text-center link_box2">{{advert.views}}</div>
      </div>
        <div class="col-4">
          <div class="alert alert-success text-center referral_heading">Clicks</div>
          <div class="alert alert-dark text-center link_box2">{{advert.clicks}}</div>
      </div>
        <div class="col-4 text-right pt-4">
        <a :href="`/campaigns/view/${advert.campaign.id}`"><i class="fa-solid fa-arrow-left pr-2"></i>Back to campaign</a><span class="px-2">&bull;</span> 
    <a :href="advert.image" target="_blank">See advert</a>
        </div>
    </div>

    <b-card no-body>
        <b-tabs v-model="tabIndex" card align="center">
          <b-tab title="Views" title-link-class="darklink">
            <b-card-text>
              <advert-views :advert_id="advert.id"></advert-views>
            </b-card-text>
          </b-tab>
          <b-tab title="Clicks" title-link-class="darklink">
            <b-card-text>
              <advert-clicks :advert_id="advert.id"></advert-clicks>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
</div>
</template> 

<script>
export default {
  props: ['advert'],

  data() {
    return {
      tabIndex: 0,
    };
  },

  methods: {

  },

};
</script>

<style scoped>
.link_box:hover, .clipboard:hover {
    cursor: pointer;
}
.referral_heading {
  border-top-left-radius: 5px; 
  border-top-right-radius: 5px; 
  border-bottom-left-radius: 0; 
  border-bottom-right-radius: 0;
}

.link_box, .link_box2 {
  border-bottom-left-radius: 5px; 
  border-bottom-right-radius: 5px;
  border-top-left-radius: 0; 
  border-top-right-radius: 0;
  font-size: 0.9rem;
  padding: 0.5rem 0.5rem !important;
}

.alert {
  margin-bottom: 0;
}
.alert-dark {
  color: #1b1e21;
  background-color: #fff;
  border-color: #0c0c0c;
}

.alert-success {
  color: #fff;
  background-color: #0c0c0c;
  border-color: #0c0c0c;
  font-size: 0.9rem;
  font-weight: 300;
  padding: 0.3rem 0.5rem !important;
}
</style>